<span #stickyPopover="stickyPopover"
      [stickyPopover]="popContent"
      [popoverTitle]="popTitle"
      [autoClose]="false"
      [animation]="false"
      [openDelay]="300"
      popoverClass='footprint-popover'
      container="body"
      triggers="manual"
      placement="auto">
</span>

<ng-template #popTitle>
  <i class="fa-light fa-hexagon text-warning me-1"></i>Footprint {{footprint?.sourceName}}
</ng-template>

<ng-template #popContent>
  <ul ngbNav
      #nav="ngbNav"
      class="nav-tabs"
      [animation]="false"
      [destroyOnHide]="false">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <i class="fa-light fa-eye me-1"></i>Observation
      </a>
      <ng-template ngbNavContent>
        <ul [style.width.px]="width"
            [style.height.px]="height"
            class="list list-unstyled mb-0">
          <li><strong>Source</strong>: {{footprint?.sourceName}}</li>
          <li><strong>RA Dec</strong>: {{(footprint?.ra | raHms) + ' ' + (footprint?.dec | decDms)}}</li>
          <li><strong>Galactic lon - lat </strong>: {{getLonLatInterval(footprint?.galacticLongitude, footprint?.galacticLatitude)}}</li>
          <li><strong>Ecliptic lon - lat</strong>: {{getLonLatInterval(footprint?.eclipticLongitude, footprint?.eclipticLatitude)}}</li>
          <li><strong>Release date</strong>: {{footprint?.releaseDate}}</li>
          <li><strong>Frequency range</strong>: {{footprint?.freqMin | number}}..{{footprint?.freqMax | number}} GHz
          </li>
          <li><strong>Frequency resolution</strong>: {{footprint?.frequencyResolution | number}} kHz</li>
          <li><strong>Continuum sensitivity</strong>: {{footprint?.continuumSensitivity | number}}</li>
          <li><strong>Array</strong>: {{footprint?.array}}</li>
          <li><strong>Band</strong>: {{footprint?.band}}</li>
        </ul>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink><i class="fa-light fa-lightbulb me-1"></i>Project</a>
      <ng-template ngbNavContent>
        <ul [style.width.px]="width"
            [style.height.px]="height"
            [style.overflow-y]="'scroll'"
            class="list list-unstyled d-flex flex-column gap-2 mb-0">
          <li><strong>Code</strong>: {{footprint?.project?.code}}</li>
          <li><strong>Title</strong>: {{footprint?.project?.title}}</li>
          <li><strong>PI Name</strong>: {{footprint?.project?.piName}}</li>
          <li><strong>Abstract</strong>: {{footprint?.project?.proposalAbstract}}</li>
        </ul>
      </ng-template>
    </li>
    <li *ngIf="footprint?.publications?.length" [ngbNavItem]="3">
      <a ngbNavLink><i class="fa-light fa-book me-1"></i>Publications ({{footprint?.publications?.length}})</a>
      <ng-template ngbNavContent>
        <ngx-datatable
          class="footprint-publications bootstrap striped m-1"
          [style.height.px]="rowHeight + headerHeight"
          [scrollbarV]="true"
          [scrollbarH]="false"
          [rows]="footprint?.publications || []"
          [messages]="{emptyMessage: '', totalMessage: 'total'}"
          [columnMode]="ColumnMode.standard"
          [headerHeight]="headerHeight"
          [footerHeight]="0"
          [rowHeight]="rowHeight">
          <ngx-datatable-column name="BibCode" prop="bibCode" [width]="150">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <a publicationLink [bibCode]="value"></a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="First Author" prop="firstAuthor" [width]="120"></ngx-datatable-column>
          <ngx-datatable-column name="Year" prop="publicationYear" [width]="70"></ngx-datatable-column>
          <ngx-datatable-column name="Title" prop="title" [width]="150"></ngx-datatable-column>
        </ngx-datatable>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</ng-template>
